import React, { Component } from 'react'
import { connect } from 'react-redux'

import RaisedButton from 'material-ui/RaisedButton'

import { reportType, getReport } from 'selectors/reports'

import fileSaver from 'file-saver'


let select = state => ({
	reportType: reportType(state)
  , report: getReport(state)
})

export class Download extends Component{
	render(){
		let { props } = this
		return(
			<div>
				<i
					className="material-icons"
					style={{
						cursor: "pointer"
					  , display: "inline-block"
					  , fontSize: "28px"
					  , marginLeft:"12px"
					  , color: "#FFF"
					  , marginTop: "16px"
					}}
					onClick={() => {
						if(props.reportType == '1099'){
							if(props.report){
								let blob = new Blob([props.report], {type: "application/pdf"})
								fileSaver.saveAs(blob, "1099.pdf")
							}
						} else {
							var element = document.getElementById('finance-report');

						}
					}}
				>
					file_download
				</i>
			</div>
		)
	}
}

export default connect(select)(Download)



// WEBPACK FOOTER //
// ./src/routes/landlord/finances/Download.js